module.exports = __webpack_public_path__ + "static/savinglives_card_img3@2x-cebcad419960efea50ae1489bc4ba51d.jpg";